export default __webpack_public_path__ + "static/media/full-screen-image-5.7231cd79.jpg";